import baseAPI from '@/api/base';
import { EditClient, GetClient, RegisterClient } from '@/dtos/client.dto';
import {
  DELETE_CLIENT_URL,
  EDIT_CLIENT_URL,
  GET_CLIENT_URL,
  REGISTER_CLIENT_URL,
  TOGGLE_CLIENT_IS_ACTIVE_URL,
} from '@/utils/urls';
import { AxiosResponse } from 'axios';

class Client {
  static getClients = async (getClient: GetClient): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_CLIENT_URL, {
      params: getClient,
    });
    console.log('response', response);
    return response;
  };

  static registerClient = async (
    registerClient: RegisterClient
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(REGISTER_CLIENT_URL, {
      ...registerClient,
    });
    console.log('response', response);
    return response;
  };

  static editClient = async (editClient: EditClient): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(EDIT_CLIENT_URL, {
      ...editClient,
    });
    return response;
  };

  static toggleClientIsActive = async (
    editClient: EditClient
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.patch(
      TOGGLE_CLIENT_IS_ACTIVE_URL,
      {
        ...editClient,
      }
    );
    return response;
  };

  static deleteClient = async (clientId: string): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.delete(
      `${DELETE_CLIENT_URL}/${clientId}`
    );
    return response;
  };
}

export default Client;

